// extracted by mini-css-extract-plugin
module.exports = {"h1":"company_h1__fp9OK","table":"company_table__BWZUa","th":"company_th__l9_Yg"};